module.exports = __webpack_public_path__ + "e07171bdbc7405b42d4cce01bacfa0a7.ttf";